import { render, staticRenderFns } from "./ProfileGroups.vue?vue&type=template&id=22fa2e43"
import script from "./ProfileGroups.vue?vue&type=script&lang=js"
export * from "./ProfileGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports